module.exports = __webpack_public_path__ + "icon.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon.png
// module id = 630
// module chunks = 0